import Router from '../Router';
import { LeaguesController } from '../../controllers';

export default class LeaguesRouter extends Router {
	initialize( options ) {
		this.typeMenu   = 'leagues';
		this.controller = new LeaguesController( options );
	}

	get appRoutes() {
		return {
			'fantasy/leagues':                              'leagues',
			'fantasy/league/create':                        'leagueCreate',
			'fantasy/league/:id/ladder':                    'leagueLadder',
			'fantasy/league/:id/manage':                    'leagueSettings',
			'fantasy/league/join(/)(?code=:code)':          'leagueJoin',
			'fantasy/league/:id/congratulation':            'leagueCongratulation',
			'fantasy/league/:id/invites':                   'invitesAfterCreateLeague',
			'fantasy/league/:id/manage/invites':            'leagueInvites',
			'fantasy/league/regeneration':                  'leaguesRegenerateList',
			'fantasy/league/:id/regenerate':                'leagueRegenerate',
			'fantasy/league/:id/regenerate/invite/:old_id': 'leagueRegenerateInvites',
			'fantasy/league/:id/regenerate/congratulation': 'leagueRegenerateCongratulation',
			'fantasy/league/:id/fixtures':                  'leagueFixtures',
			'fantasy/league/:id/matchup/:home_team_id/:away_team_id/:round_id': 'matchUp'
		};
	}
}